import React, { useState } from 'react';
import { useProject } from '../context/ProjectContext';
import './ProjectSidebar.css';

const ProjectSidebar = () => {
  const { projects, selectedProject, selectProject, loading } = useProject();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleProjectSelect = (project) => {
    selectProject(project);
    setMobileMenuOpen(false); // Close mobile menu after selection
  };

  if (loading) {
    return (
      <div className={`project-sidebar ${collapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <h3>Projects</h3>
        </div>
        <div className="sidebar-content">
          <p className="loading-text">Loading projects...</p>
        </div>
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <div className={`project-sidebar ${collapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <h3>Projects</h3>
        </div>
        <div className="sidebar-content">
          <p className="no-projects-text">No projects available. Create one in the Admin panel.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Mobile hamburger button */}
      <button
        className="mobile-menu-toggle"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle project menu"
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>

      {/* Mobile overlay */}
      {mobileMenuOpen && (
        <div
          className="mobile-overlay"
          onClick={() => setMobileMenuOpen(false)}
        ></div>
      )}

      <div className={`project-sidebar ${collapsed ? 'collapsed' : ''} ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          <h3>Projects</h3>
          <button
            className="collapse-button"
            onClick={() => setCollapsed(!collapsed)}
            title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {collapsed ? '→' : '←'}
          </button>
          {/* Close button for mobile */}
          <button
            className="mobile-close-button"
            onClick={() => setMobileMenuOpen(false)}
            aria-label="Close menu"
          >
            ×
          </button>
        </div>

      {!collapsed && (
        <div className="sidebar-content">
          <div className="projects-list">
            {projects.map(project => (
              <div
                key={project.id}
                className={`project-item ${selectedProject?.id === project.id ? 'selected' : ''}`}
                onClick={() => handleProjectSelect(project)}
              >
                <div className="project-name">{project.name}</div>
                <div className="project-repository">{project.repository.name}</div>
                {project.description && (
                  <div className="project-description">{project.description}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {collapsed && (
        <div className="sidebar-content-collapsed">
          {projects.map(project => (
            <div
              key={project.id}
              className={`project-item-collapsed ${selectedProject?.id === project.id ? 'selected' : ''}`}
              onClick={() => handleProjectSelect(project)}
              title={`${project.name} (${project.repository.name})`}
            >
              {project.name.charAt(0).toUpperCase()}
            </div>
          ))}
        </div>
      )}
    </div>
    </>
  );
};

export default ProjectSidebar;
